class WishlistCollection extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.listeners.add(this, 'click', this.handleTrigger)

    window.SwymCallbacks = window.SwymCallbacks || []

    // Only register once: refreshWishlistState() updates every
    // wishlist-collection instance on the page, so registering per-card
    // would fire a fetchLists request per card on every callback.
    if (!window.__wishlistCollectionCallbackRegistered) {
      window.__wishlistCollectionCallbackRegistered = true
      window.SwymCallbacks.push(() => this.refreshWishlistState())

      // Fallback: reveal icons even if Swym never calls back (e.g. blocked
      // by an ad blocker), so they don't stay hidden forever.
      setTimeout(() => {
        document.documentElement.setAttribute('data-wishlist-app-ready', '')
      }, 5000)

      // bfcache restores (e.g. hitting back) thaw the page exactly as it was
      // left, with no new requests firing - re-sync in case the wishlist
      // changed elsewhere while the page was cached.
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) this.refreshWishlistState()
      })
    }
  }

  isLoggedIn () {
    return this.hasAttribute('data-is-customer')
  }

  get triggerEl () {
    return this.querySelector('[data-wishlist-trigger-el="trigger"]')
  }

  handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-wishlist-trigger-el="trigger"]',
    )
    if (!trigger || !window._swat) return

    if (!this.isLoggedIn()) {
      this.showLoginAlert()
      return
    }

    const product = {
      epi: Number(trigger.dataset.variantId),
      empi: Number(trigger.dataset.productId),
      du: trigger.dataset.productUrl,
    }

    // REMOVE
    if (trigger.hasAttribute('data-wishlist-added')) {
      const lid = trigger.dataset.wishlistId

      // Optimistic: unfill immediately, re-fill if the request fails
      trigger.removeAttribute('data-wishlist-added')
      delete trigger.dataset.wishlistId

      window._swat.deleteFromList(
        lid,
        product,
        () => this.refreshAfterChange(),
        (error) => {
          console.error(error)
          trigger.setAttribute('data-wishlist-added', '')
          trigger.dataset.wishlistId = lid
        },
      )
      return
    }

    // ADD

    // Optimistic: fill immediately, unfill if the request fails
    trigger.setAttribute('data-wishlist-added', '')

    this.addToWishlist('My wishlist', product, trigger)
  }

  addToWishlist (name, product, trigger) {
    window._swat.fetchLists({
      callbackFn: (lists) => {
        const existing = lists.find((l) => l.listname === name)

        if (existing) {
          this.addProduct(existing.lid, product, trigger)
        } else {
          window._swat.createList(
            { lname: name },
            (newList) => this.addProduct(newList.lid, product, trigger),
            (error) => {
              console.error(error)
              trigger.removeAttribute('data-wishlist-added')
            },
          )
        }
      },
      errorFn: (error) => {
        console.error(error)
        trigger.removeAttribute('data-wishlist-added')
      },
    })
  }

  addProduct (lid, product, trigger) {
    window._swat.addToList(
      lid,
      product,
      () => this.refreshAfterChange(),
      (error) => {
        console.error(error)
        trigger.removeAttribute('data-wishlist-added')
      },
    )
  }

  refreshAfterChange () {
    // 🔥 CRITICAL: Swym is async/eventual consistency
    setTimeout(() => {
      this.refreshWishlistState()
    }, 300)
  }

  refreshWishlistState () {
    // Guests have nothing saved and can't fetch a wishlist - skip Swym
    // entirely and just make sure every icon shows as unchecked.
    if (!this.isLoggedIn()) {
      document.querySelectorAll('wishlist-collection').forEach((component) => {
        const el = component.triggerEl
        if (!el) return

        el.removeAttribute('data-wishlist-added')
        delete el.dataset.wishlistId
      })

      document.documentElement.setAttribute('data-wishlist-app-ready', '')
      return
    }

    if (!window._swat) return

    window._swat.fetchLists({
      callbackFn: (lists) => {
        const wishlistItems = new Map()

        lists.forEach((list) => {
          list.listcontents?.forEach((item) => {
            wishlistItems.set(Number(item.epi), list.lid)
          })
        })

        document
          .querySelectorAll('wishlist-collection')
          .forEach((component) => {
            const el = component.triggerEl
            if (!el) return

            const variantId = Number(el.dataset.variantId)
            const matchListId = wishlistItems.get(variantId)

            if (matchListId) {
              el.setAttribute('data-wishlist-added', '')
              el.dataset.wishlistId = matchListId
            } else {
              el.removeAttribute('data-wishlist-added')
              delete el.dataset.wishlistId
            }
          })

        document.documentElement.setAttribute('data-wishlist-app-ready', '')
      },
      errorFn: (error) => {
        console.error(error)
        document.documentElement.setAttribute('data-wishlist-app-ready', '')
      },
    })
  }

  showLoginAlert () {
    const alert = this.externalEls.alert?.element
    if (!alert) return

    alert.removeAttribute('hidden')
    setTimeout(() => alert.setAttribute('hidden', ''), 4000)
  }
}

if (!customElements.get('wishlist-collection')) {
  customElements.define('wishlist-collection', WishlistCollection)
}
